/**
 * AudioRecorder - Module d'enregistrement audio isolé
 *
 * Peut être supprimé sans impact sur le reste de l'application.
 * Utilise Tone.Recorder pour capturer la sortie master.
 */

import * as Tone from 'tone';

export class AudioRecorder {
    constructor() {
        this.recorder = null;
        this.isRecording = false;
        this.onStateChange = null; // Callback pour notifier les changements d'état
    }

    /**
     * Initialise le recorder (à appeler après que l'audio context soit démarré)
     */
    init() {
        if (this.recorder) return;

        this.recorder = new Tone.Recorder();
        Tone.getDestination().connect(this.recorder);
    }

    /**
     * Démarre l'enregistrement
     */
    async start() {
        if (this.isRecording) return;

        // S'assurer que le recorder est initialisé
        this.init();

        // S'assurer que l'audio context est démarré
        if (Tone.context.state !== 'running') {
            await Tone.start();
        }

        await this.recorder.start();
        this.isRecording = true;

        if (this.onStateChange) {
            this.onStateChange(true);
        }
    }

    /**
     * Arrête l'enregistrement et retourne le blob audio
     * @returns {Promise<Blob>} Le fichier audio enregistré
     */
    async stop() {
        if (!this.isRecording) return null;

        const recording = await this.recorder.stop();
        this.isRecording = false;

        if (this.onStateChange) {
            this.onStateChange(false);
        }

        return recording;
    }

    /**
     * Arrête l'enregistrement et télécharge le fichier
     * @param {string} filename - Nom du fichier (sans extension)
     */
    async stopAndDownload(filename = 'rebirth-recording') {
        const recording = await this.stop();
        if (!recording) return;

        // Créer l'URL et télécharger
        const url = URL.createObjectURL(recording);
        const timestamp = new Date().toISOString().slice(0, 19).replace(/[:-]/g, '');

        const a = document.createElement('a');
        a.href = url;
        a.download = `${filename}-${timestamp}.webm`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);

        // Libérer l'URL
        setTimeout(() => URL.revokeObjectURL(url), 1000);
    }

    /**
     * Retourne l'état d'enregistrement
     */
    getState() {
        return this.isRecording;
    }

    /**
     * Nettoie les ressources
     */
    destroy() {
        if (this.recorder) {
            if (this.isRecording) {
                this.recorder.stop();
            }
            this.recorder.dispose();
            this.recorder = null;
        }
        this.isRecording = false;
    }
}
